import { ElementType } from "react";

import ContractualIcon from "../assets/icons/sidebar/ContractualIcon";
import DashboardIcon from "../assets/icons/sidebar/DashboardIcon";
import JobIcon from "../assets/icons/sidebar/JobIcon";
import MyProjectsIcon from "../assets/icons/sidebar/MyProjectsIcon";
import NotificationIcon from "../assets/icons/sidebar/NotificationIcon";
import OrganizationIcon from "../assets/icons/sidebar/OrganizationIcon";
import PaymentIcon from "../assets/icons/sidebar/PaymentIcon";
import ProposalsIcon from "../assets/icons/sidebar/ProposalsIcon";
import SettingsIcon from "../assets/icons/sidebar/SettingsIcon";
import SurveyIcon from "../assets/icons/sidebar/SurveyIcon";
import { Role } from "../types/common";

interface MenuType {
  name: string;
  path: string;
  icon?: ElementType;
  badge?: string;
  role: Role[];
}

interface MenuTypes extends MenuType {
  children?: MenuType[];
}

const AllSidebarMenu: MenuTypes[] = [
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: DashboardIcon,
    role: ["admin"],
  },
  {
    name: "Organizations",
    path: "/admin/organizations",
    icon: OrganizationIcon,
    role: ["admin"],
    children: [
      {
        name: "Organization List",
        path: "/admin/organizations/list",
        role: ["admin"],
      },
    ],
  },
  // organization
  {
    name: "Dashboard",
    path: "/organization/dashboard",
    icon: DashboardIcon,
    role: ["organization_admin"],
  },
  {
    name: "Post a Job",
    path: "/organization/job-list",
    icon: JobIcon,
    role: ["organization_admin"],
  },
  {
    name: "Proposals",
    path: "/organization/proposals",
    icon: ProposalsIcon,
    role: ["organization_admin"],
  },
  {
    name: "My Projects",
    path: "/organization/my-projects",
    icon: MyProjectsIcon,
    role: ["organization_admin"],
  },
  {
    name: "Contractual",
    path: "/organization/contractual",
    icon: ContractualIcon,
    role: ["organization_admin"],
    children: [
      {
        name: "Salary Slab",
        path: "/organization/contractual/salary-slab",
        role: ["organization_admin"],
      },
      {
        name: "Shift Management",
        path: "/organization/contractual/shift-management",
        role: ["organization_admin"],
      },
      {
        name: "KPI Setup",
        path: "/organization/contractual/kpi-setup",
        role: ["organization_admin"],
      },
      {
        name: "Leave Management",
        path: "/organization/contractual/leave-management",
        role: ["organization_admin"],
      },
      {
        name: "Payroll",
        path: "/organization/contractual/payroll",
        role: ["organization_admin"],
      },
      {
        name: "Attendance Management",
        path: "/organization/contractual/attendance-management",
        role: ["organization_admin"],
      },
    ],
  },
  // {
  //   name: "Messages",
  //   path: "/organization/messages",
  //   icon: MessageIcon,
  //   role: ["organization_admin"],
  // },
  {
    name: "Survey",
    path: "/organizations/survey",
    icon: SurveyIcon,
    role: ["organization_admin"],
    children: [
      {
        name: "Templates",
        path: "/organizations/survey/templates",
        role: ["organization_admin"],
      },
      {
        name: "Survey Data",
        path: "/organizations/survey/survey-data-list",
        role: ["organization_admin"],
      },
    ],
  },
  {
    name: "Payment",
    path: "/organization/payment",
    icon: PaymentIcon,
    role: ["organization_admin"],
  },
  {
    name: "Settings",
    path: "/organization/settings",
    icon: SettingsIcon,
    role: ["organization_admin"],
  },
  {
    name: "Notification",
    path: "/organization/notification",
    icon: NotificationIcon,
    role: ["organization_admin"],
  },
];

export default AllSidebarMenu;
